export const formatName = (firstName, lastName) => {
  // Default to empty strings if parameters are null or undefined
  firstName = (firstName ?? '').trim();
  lastName = (lastName ?? '').trim();

  // Get the first letter of the first name, capitalize and add a dot
  const initial = firstName ? `${firstName.charAt(0).toUpperCase()}.` : '';

  // Preserve the surname exactly as configured in the user table.
  return `${initial} ${lastName}`.trim();
};
